<template>
    <v-content>        
        <!--<page-header v-if="$route.meta.breadcrumb"></page-header>-->
        
        <router-view style="margin-bottom: 50px" />
        
        <footer class="v-footer white pa-3 app--footer">
            <span class="caption">
                {{footerCopyright}}
            </span> 
            <div class="spacer"></div> 
            <span class="caption mr-1"> {{footerTagline}} </span> 
            <i aria-hidden="true" class="v-icon pink--text material-icons" style="font-size: 20px;">{{footerIcon}}</i>
        </footer>        
    </v-content>   
</template>

<script>
import PageHeader from './PageHeader';

export default {
  name: 'app-content',
  components: { 
    PageHeader,    
    
  },
  data: () => ({
    footerCopyright: 'SangkilSoft Team © 2018',
    footerTagline  : 'Make With Spirit',
    footerIcon     : 'android',    
  }),

  methods: {
    
  }
};
</script>
<style>

</style>